import React from "react";
import { Link } from "react-router-dom";

export default function Team() {
  const goHome = () => {
 window.location.to ="https://sunrisemeditechsystems.com";
};
    return(
        <>
        {/* BREADCRUMB AREA START */}
        <div
          className="ltn__breadcrumb-area text-left bg-overlay-white-30 bg-image "
          data-bs-bg="img/bg/sunrise-medical.jpg"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="ltn__breadcrumb-inner">
                  <h1 className="page-title">Our Team</h1>
                  <div className="ltn__breadcrumb-list">
                    <ul>
                      <li>
                        <Link
                        to="#"
                        onClick={goHome}
                        className="bg-black-color"
                        style={{ cursor: "pointer" }}
                      >
                        <span className="ltn__secondary-color">
                          <i className="fas fa-home bg-black-color" />
                        </span>{" "}
                        Home
                      </Link>
                      </li>
                      <li>Team</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* BREADCRUMB AREA END */}
        {/* TEAM AREA START (Team - 3) */}
        <div className="ltn__team-area pt-110--- pb-90">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/4.jpg" alt="Image1" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <Link to="team-details.html">Rosalina D. William</Link>
                    </h4>
                    <h6 className="ltn__secondary-color">Scientist</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/2.jpg" alt="Image2" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <Link to="team-details.html">Kelian Anderson</Link>
                    </h4>
                    <h6 className="ltn__secondary-color">Dentist</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/3.jpg" alt="Image3" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <Link to="team-details.html">Miranda H. Halim</Link>
                    </h4>
                    <h6 className="ltn__secondary-color">Caardiologist</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/1.jpg" alt="Image4" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <Link to="team-details.html">Damble D. Browni.</Link>
                    </h4>
                    <h6 className="ltn__secondary-color">Assistant</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/5.jpg" alt="Image5" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <Link to="team-details.html">Aiden Benjamin</Link>
                    </h4>
                    <h6 className="ltn__secondary-color">Scientist</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="ltn__team-item ltn__team-item-3---">
                  <div className="team-img">
                    <img src="img/team/6.jpg" alt="Image6" />
                  </div>
                  <div className="team-info">
                    <h4>
                      <Link to="team-details.html">James Carter</Link>
                    </h4>
                    <h6 className="ltn__secondary-color">Dentist</h6>
                    <div className="ltn__social-media">
                      <ul>
                        <li>
                          <Link to="#">
                            <i className="fab fa-facebook-f" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-twitter" />
                          </Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="fab fa-linkedin" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* TEAM AREA END */}
      </>
      
    );

}